module.exports = __webpack_public_path__ + "static/media/login-ez.946c02ab.png";